import { connect } from 'react-redux'
import ContactListDetailsView from './ContactListDetailsView.jsx'
import { fetchContactList, viewContactList, removeContactFromContactList, updateContactList } from 'src/legacy/redux/actions/contactList';

const mapStateToProps = (state, ownProps) => {
  var id = ownProps.id;
  var contactList = state.legacyRootReducer.contactLists.contactList[id];

  return {
    contactLists: state.legacyRootReducer.contactLists.items,
    contactList: contactList ? contactList.item : null,
    loading: contactList ? contactList.loading : false || state.legacyRootReducer.contactLists.loading,
    updating: contactList ? contactList.updating : false,
    user: state.users.me
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchContactList: (id) => {
      return dispatch(fetchContactList(id));
    },

    viewContactList: (id) => {
      return dispatch(viewContactList(id));
    },

    updateContactList: (id, contact) => {
      return dispatch(updateContactList(id, contact));
    },

    removeContactFromContactList: (contactListId, contact) => {
      return dispatch(removeContactFromContactList(contactListId, contact))
    },
  }
}

const ContactListDetailsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactListDetailsView)

export default ContactListDetailsContainer